/* eslint-disable react/display-name */
import React, { useRef, useState, useEffect, ComponentProps } from 'react';
import ReactDatePicker, { ReactDatePickerProps, registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { format } from 'date-fns';
import { useField } from '@unform/core';
import { Icon, Label, TextField } from 'components';
import './styles.css';

import ptBR from 'date-fns/locale/pt-BR';
import { Flex, InputGroup, InputLeftElement } from '@chakra-ui/react';
registerLocale('br', ptBR);

interface IProps extends Omit<ReactDatePickerProps, 'onChange'> {
  name: string;
}

type InputProps = ComponentProps<typeof TextField> & IProps;

function DatePicker({ name, disabled, ...rest }: InputProps) {
  const datepickerRef = useRef<any>(null);
  const { fieldName, registerField } = useField(name);

  const [date, setDate] = useState<any>('');

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: datepickerRef.current,
      clearValue: ref => {
        ref.clear();
      },
      getValue: ref => {
        try {
          return format(ref.props.selected, 'dd/MM/yyyy');
        } catch (e) {}
      },
    });
  }, [fieldName, registerField]);

  const { label, tip, labelColor, leftIcon } = rest;

  const handleClick = () => {
    datepickerRef.current?.deferFocusInput();
  };

  function allowOnlyNumbersAndSlash(event: any) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed = event.nativeEvent.data;
    const inputType = event.nativeEvent.inputType;
    const defaultValue = event.target.defaultValue;
    const target = event.target;

    if (target.value?.length === 2 && inputType !== 'deleteContentBackward') {
      target.value += '/';
    }
    if (target.value?.length === 5 && inputType !== 'deleteContentBackward') {
      target.value += '/';
    }

    if (!allowedKeys.includes(keyPressed) && inputType !== 'deleteContentBackward') {
      event.preventDefault();
    } else if (defaultValue.length === 10 && inputType !== 'deleteContentBackward') {
      event.preventDefault();
    }
  }

  return (
    <>
      <Label color={labelColor} tip={tip} htmlFor={'datePicker'}>
        {label}
      </Label>
      <Flex w="100%" position="relative">
        <InputGroup position="absolute" top="1.2rem" left="-0.3rem" onClick={handleClick}>
          <InputLeftElement height={'100%'}>
            <Icon name="th" {...(typeof leftIcon === 'string' ? { name: leftIcon } : leftIcon)} />
          </InputLeftElement>
        </InputGroup>
        <ReactDatePicker
          ref={datepickerRef}
          selected={date}
          onSelect={setDate}
          onChange={setDate}
          id="datePicker"
          className="datePicker"
          // customInput={<Calendar {...rest} inputRef={inputRef} />}
          dateFormat="dd/MM/yyyy"
          locale="br"
          disabled={disabled}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          placeholderText="__/__/____"
          onChangeRaw={allowOnlyNumbersAndSlash}
          timeFormat="dd/MM/yyyy"
        />
      </Flex>
    </>
  );
}

export const DateInput = React.memo(DatePicker);
